/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import clsx from "clsx";
import {PersonsType} from "types/enums/PersonsType";
import React from "react";
import {Timeslot} from "types/entities/Timeslot";

interface TimeslotProps {
    timeslot: Timeslot;
}

export const TimeslotFilled = (props: TimeslotProps) => {
    const filledPercentage = (props.timeslot.persons_filled / props.timeslot.persons_max) * 100;

    const getBackgroundByPersonType = (personsType: PersonsType) => {
        switch (personsType) {
            case PersonsType.Unknown:
                return "bg-arboPark-100";
            case PersonsType.Adult:
                return "bg-blue-400";

            case PersonsType.Child:
                return "bg-green-400";

            case PersonsType.Family:
                return "bg-yellow-400";
            default:
                return "bg-gray-700";
        }
    };
    return (
        <div
            className={clsx(getBackgroundByPersonType(props.timeslot.persons_type), "w-full absolute z-1 inset-x-0 bottom-0 bg-opacity-30")}
            style={{
                height: filledPercentage + "%",
            }}
        />
    );
};
